//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'

export default {
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	components: {
		ResponsiveImageStrapi,
	},

	computed: {
		posts() {
			// const re = this.$store.getters.cmsdata;
			// console.log('d index: ', re.home)
			return this.$store.getters.posts
		},
	},
	async asyncData({
      params,
      error,
      store
    }) {
      // console.log("async page _slug: ", params.slug);
      try {
        await store.dispatch('getPostsAll')
      } catch (e) {
        error({
          statusCode: e.statusCode,
          message: e.message
        })
      }
    },
}
